module.exports = __webpack_public_path__ + "static/media/icon-collapse.9bfe4a1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/compare-section/img/icon-collapse.svg
// module id = 960
// module chunks = 1